import styles from "./rating.module.css"
import { Button, Modal } from "react-bootstrap"
import { useEffect, useState } from "react"
import { BanOutline, Heart, Mail, Phone, ThumbDown, ThumbUp } from "heroicons-react";
import { Spinner } from "flowbite-react";
interface Props {
  showModal: boolean | undefined
  hideModal: any
}

export function InfoModal(props: Props) {
  const [show, setShow] = useState(false)
  const handleShow = () => setShow(true)

  useEffect(() => {
    console.log("useEffect show modal")
    handleShow()
  }, [props.showModal])
  function close() {
    props.hideModal(false)
    setShow(false)
  }


  return (
    <Modal dialogClassName="custom-dialog" show={show} onHide={close}>
      <Modal.Header closeButton={true}>
        <Modal.Title>
          <span className={styles.title} >  Helpdesk</span>
          <Button className={styles.btn} onClick={close}>
            X
          </Button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
            <div className={styles.body} >
              <div className={styles.title2} >Störung am Musiksystem? </div>
              <div className={styles.title3} >Kontaktieren Sie unser Helpdesk. </div>
            <div className={styles.contact}>
              <div className={styles.title4}>M-Cube Deutschland GmbH</div>
              {/*<div> <a className={styles.link} href="tel:004969698677615"> <Phone className={styles.icon}></Phone>+49 (0)69 69 86 77 615</a></div>*/}
              {/*<div>  <a className={styles.link} href="mailto:support.storever@mcubedigital.com"><Mail className={styles.icon} ></Mail>support.storever@mcubedigital.com</a></div>*/}

              <div>
                <a className={styles.link} href="tel:004969698677615"> <Phone size={50} className={styles.icon}></Phone></a>
                <a className={styles.link} href="mailto:support.storever@mcubedigital.com"><Mail size={50} className={styles.icon} ></Mail></a>
              </div>
            </div>

            </div>
      </Modal.Body>
      {/*<Modal.Footer>*/}
      {/*  /!*<Button className={styles.btn} onClick={close}>*!/*/}
      {/*  /!*  Close*!/*/}
      {/*  /!*</Button>*!/*/}
      {/*</Modal.Footer>*/}
    </Modal>
  )
}
